<script>
  /**
   * 複数選択可能なチェックボックスを羅列する UI
   * - チェックボックスの後ろに選択値をラベルとして表示
   */
  import Field from './Field.svelte'
  import { scrollOnFocus } from '../../modules/scrollOnFocus'

  export let id
  export let name
  export let label
  export let values = [] // 選択可能な値の配列
  export let checked = [] // チェックされた値の配列
  export let isLoading = false
  export let style = undefined
</script>

<Field {id} {label} {isLoading}>
  {#each values as value, index}
    {@const checkboxId = `${id}-Checkbox${index}`}
    {@const labelId = `${checkboxId}Label`}
    <label
      class="checkbox"
      id={labelId}
      data-testid={labelId}
      for={checkboxId}
      {style}
    >
      <input
        type="checkbox"
        id={checkboxId}
        data-testid={checkboxId}
        {name}
        {value}
        bind:group={checked}
        {style}
        use:scrollOnFocus
      />
      {value}
    </label>
  {/each}
</Field>
